<template>
  <section id="my-profile">
    <Profile />
    <Settings />
  </section>
</template>

<script>
import Profile from '../../components/MyProfile/Profile.vue';
import Settings from '../../components/MyProfile/Settings.vue';

export default {
  components: {
    Profile,
    Settings,
  },
};
</script>

<style lang="scss" scoped src="./MyProfile.scss"></style>
